// @flow

import * as React from "react";
import { NavLink } from "react-router-dom";

import processInternalUrl from "../../utils/processInternalUrl";
import isExternalUrl from "../../utils/isExternalUrl";

const LinkHandler = (props: any): React.Node => {
    let finalUrl = processInternalUrl(props.to);

    // Decide which element type to use based off relative/absolute url
    const LinkElement =
        !props.disabled && finalUrl
            ? isExternalUrl(finalUrl)
                ? "a"
                : NavLink
            : finalUrl
            ? "a"
            : (props.type && props.type === "button") ||
              (props.type && props.type === "submit")
            ? "button"
            : "span";

    // clean dom element props
    const preparedProps = { ...props };

    // disable active class for child pages using NavLink
    if (LinkElement.displayName === "NavLink") {
        preparedProps.exact = true;
    }

    delete preparedProps["showExternal"];
    if (finalUrl && isExternalUrl(finalUrl)) {
        delete preparedProps["activeClassName"];
    }

    return (
        <LinkElement
            {...preparedProps}
            {...(finalUrl
                ? isExternalUrl(finalUrl)
                    ? { href: finalUrl }
                    : { to: finalUrl }
                : null)}
            // aria-label={props.aria-label || ""}
        />
    );
};

export default LinkHandler;
